import { IServicePrice } from "../common/data/dtos/service-price";
import { GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/ServicePrice';

interface ServicePriceResponse {
    success: boolean;
    servicePrice?: IServicePrice;
    servicePrices?: IServicePrice[];
    error?: string;
}

type CreateServicePriceType = Omit<IServicePrice, 'id'> | Partial<IServicePrice>;

const createServicePrice = async (service: CreateServicePriceType): Promise<ServicePriceResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IServicePrice>(`${BASE_PATH}`, service);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateServicePrice = async (servicePrice: IServicePrice): Promise<ServicePriceResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IServicePrice>(`${BASE_PATH}/${servicePrice.id}`, servicePrice);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getActiveByService = async (id: string, customerId: string): Promise<ServicePriceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IServicePrice>(`${BASE_PATH}/GetActiveByService?id=${id}&customerId=${customerId}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, servicePrice: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getByCustomer = async (customerId: string, serviceId: string): Promise<ServicePriceResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IServicePrice>(`${BASE_PATH}/getByCustomer?customerId=${customerId}&serviceId=${serviceId}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, servicePrice: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createServicePrice,
    updateServicePrice,
    getActiveByService,
    getByCustomer
}